var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';

var Battery = function Battery(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), React.createElement("title", null, title), React.createElement("path", {
    fill: "currentColor",
    d: "M89.6 38.09V80.7H10.4V38.09h79.2m5.4-5.32H5v53.26h90V32.77z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M62.6 55.33h18v5.33h-18zM36.95 55.33h-6.3v-6.21h-5.4v6.21h-6.3v5.33h6.3v6.21h5.4v-6.21h6.3zM93.2 28.23h-5.4v-2.88H77.46v-6h-6.69v6H29.23v-6h-6.69v6H12.2v2.88H6.8v-8.21h10.34v-5.99h17.49v5.99h30.74v-5.99h17.49v5.99H93.2z"
  }));
};

export default Battery;